import { render } from "./IconButton.vue?vue&type=template&id=795f2e1e&scoped=true"
import script from "./IconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=795f2e1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795f2e1e"],['__file',"src/components/AirCNavBar/IconButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "795f2e1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('795f2e1e', __exports__)) {
    api.reload('795f2e1e', __exports__)
  }
  
  module.hot.accept("./IconButton.vue?vue&type=template&id=795f2e1e&scoped=true", () => {
    api.rerender('795f2e1e', render)
  })

}


export default __exports__